import { Tag } from "antd";
import type { OrgUser } from "@/common/model";

/** Active/Disabled status tag for an organization user. */
export function UserStatusBadge({ user }: { user: OrgUser }) {
	const disabled = user.disabledAt != null;
	return (
		<Tag color={disabled ? "default" : "green"}>
			{disabled ? "Disabled" : "Active"}
		</Tag>
	);
}
